import React, { useState, useContext } from "react";
import ShoppingBag from "../assets/images/navbar/ShoppingBag.png";
import logo from "../assets/images/navbar/LibasLogo.svg";
import Search from "../assets/images/Search1.png";
import { useTranslation } from "react-i18next";
import logoProf from "../assets//images/navbar/logoProf.png";
import Notification from "../assets//images/navbar/bell-empty.svg";
import avatar from "../assets/images/avatar.jpeg";
import burger from "../assets//images/navbar/burger.svg";
import NavBarMdal from "./Modals/NavBarMdal";
import SignUp from "./SignUp/SignUp";
import SignIn from "./SignIn/SignIn";
import { UserContext } from "../context/user.context";
import { getDoc, signOutUser } from "../utils/firebase/firebase.utils";
import { useEffect } from "react";
import Switch from "react-switch";
import Menu from "../Components/Menu";

import {
  db,
  collection,
  onSnapshot,
  query,
  where,
  getFirebaseToken,
  updateDoc,
  orderBy,
  doc,
} from "../utils/firebase/firebase.utils";
import { SelectedCurrencies } from "../features/Currency/CurrencySlice";
import SearchComponent from "./Search";
import {
  GetBalances,
  SetFlags,
  SetReferlength,
  SetShowOffer,
  SetUpdateReferral,
} from "../features/Flags/FlagsSlice";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Currency } from "./Bags/Currency";
import { FillMybags } from "../features/Bag/MybagSlice";
import ForgetPassword from "./ForgetPassword/ForgetPassword";
import {
  GetProductAlsoLike,
  GetProductJustViewdd,
  GetProductNewDrops,
  GetProductFromSeller,
  GetProductTopPicks,
  GetLibasProduct,
  GetAllChanel,
  GetAllAmina,
  GetAllPradaReEdition,
  GetAllChanelBoy,
  GetAllBottega,
  GetAllHermes,
  IsProductAlsoLike,
  IsDrops,
  IsJustView,
  IsTopPicks,
  IsProductFromSeller,
  IsProductLibas,
  GetAllProductVintage,
  IsVintage,
  IsChanel,
  IsAmina,
  IsPradaReEdition,
  IsChanelBoy,
  IsBottega,
  IsHermes,
  IsBirkin,
  GetAllBirkin,
  GetAllBurberry,
  IsBurberry,
  GetAllLV,
  GetAllDG,
  GetAllMM,
  GetAllZadig,
  GetAllDisel,
  GetAllGucci,
  IsDG,
  IsGucci,
  IsDisel,
  IsLV,
  IsMM,
  IsZadug,
  GetAllMyFollowers,
  SetSelectdPage,
  SetSizeFilter,
  SetBottomSizeFilter,
  SetTopSizeFilter,
  SortProducts,
  resetLoadingNumber,
  SetSignIn,
  SetSignUpp,
  getAllProductOnline,
  getLastDoc,
  SetNotifications,
  // getAllProductOnline,
  // getLastDoc,
} from "../features/Products/ProductSlice";
import { SetAddresses } from "../features/Addresses/AddressesSlice";
import { GetAllProductViewd } from "../features/RecentlyViewed/RecentlyViewed";
// import { SetLang } from "../features/Languages/LanguageSilce";

import {
  GetTopSeacrhes,
  SetSearch,
  SetTopSeacrhes,
} from "../features/TopSearches/TopSearchesSlice";
import TopPicksSeacrh from "./TopPicksSeacrh";
import branch from "branch-sdk";
import NotificationMap from "./NotificationMap";
import { NOTIFICATION_TYPE_PRODUCT_PRICE_DROP } from "../constants/constants";
import NotificationModal from "./Modals/NotificationModal";
// import { event } from "jquery";
import SearchMenuModal from "./Modals/Seacrh/SearchMenuModal";
import Aos from "aos";
import ReferalModal from "./Modals/ReferalProgram/ReferalModal";
import ThankYouModal from "./Modals/ReferalProgram/ThankYouModal";
// import { SearchProductQuery } from "../utils/Filters/ProductSeacrhQuery";
// import OfferModal from "./Modals/OfferModal";

function NavBar() {
  const { t, i18n } = useTranslation();
  let parametres = new URLSearchParams(useLocation().search);
  const { currencies, selectedcurrency, currencydefault } = useSelector(
    (store) => store.currency
  );
  const [hovermenu, setHoverMenu] = useState(false);

  const { mybags } = useSelector((store) => store.mybag);
  const { users } = useSelector((store) => store.allproducts);
  const { showOffer, referralcode } = useSelector((store) => store.flags);
  console.log(mybags, "mybags");
  const dispatch = useDispatch();
  const [showNotification, setShowNotification] = useState(false);
  const [showreferral, SetShowReferral] = useState(false);
  const [showcongrats, SetShowCongrats] = useState(false);
  // const [showOffer, setShowOffer] = useState(true);

  const [seacrhDrop, setSeacrhDrop] = useState(false);

  const [forgetpassword, setForgetpassword] = useState(false);
  const [signIn, setSignIn] = useState(false);
  const [signUp, setSignUp] = useState(false);
  const [checked, setChecked] = useState(false);
  const [checkedlang, setCheckedLang] = useState(true);
  const [checkedlan, setCheckedlan] = useState(false);
  const [searchQ, setSearchQ] = useState("");
  const { currentUser, showSearchh, setShowSearchh } = useContext(UserContext);
  const [notifications, setNotifications] = useState([]);
  const [referralcodeuser, setReferralcodeuser] = useState([]);

  const { topsearchquery, searchQuary } = useSelector(
    (store) => store.topsearches
  );
  const { constant, referlength, balances } = useSelector(
    (store) => store.flags
  );

  const [showSearch, setShowSeacrh] = useState(false);
  // const [showReferal, setShowReferal] = useState(false);
  // const[showThankyou,setShowThankyou]=useState(false);
  const { onlineproducts } = useSelector((store) => store.allproducts);

  const handleChange = (e) => {
    dispatch(SelectedCurrencies(e.target.value));
  };

  const handleCheck = (e) => {
    setChecked(e);
    if (e) {
      dispatch(SelectedCurrencies("1YiC1Sz9MkYPY3LG8MlN"));
    } else {
      dispatch(SelectedCurrencies("papAwH0XoKC3AmT9YmR7"));
    }
  };

  // count carts
  useEffect(() => {
    const fetchCart = async () => {
      try {
        const cartRef = doc(db, "carts", "MlbIbUZVjjglMcOsexTV5wk06fM2");
        const cartSnapshot = await getDoc(cartRef);

        console.log(cartSnapshot.data(), "usercart");
      } catch (err) {
        console.log(err, "error fetching cart data");
      }
    };

    fetchCart();
  }, []);

  function handleSearch(event) {
    if (event.key === "Enter" || event.key === "Done") {
      dispatch(getAllProductOnline([]));
      dispatch(SetSearch(event.target.value));
      setSeacrhDrop(false);
      dispatch(SetSelectdPage(0));
      sessionStorage.setItem("selectedItemIndex", "");
      dispatch(resetLoadingNumber(30));
      dispatch(SortProducts(""));
      dispatch(SetSizeFilter([]));
      dispatch(SetTopSizeFilter([]));
      dispatch(SetBottomSizeFilter([]));
      // dispatch(getAllProductOnline([]));dispatch(getLastDoc(null))
      // if (parametres.get('topic') != null)
      // {
      //    navigate(`/products?topic=${parametres.get('topic')}`) }
      // else {
      navigate("/products");
      // }
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    } else {
      setSeacrhDrop(true);
    }
  }

  const navigate = useNavigate();
  const currency = JSON.parse(localStorage.getItem("currency"));
  const collRef = collection(db, "currency");
  const languages = JSON.parse(localStorage.getItem("language"));
  //console.log(languages)
  const flag = collection(db, "flags");
  const USERS = collection(db, "users");

  const topSearches = collection(db, "topSearches");
  const searches = query(topSearches, orderBy("order", "asc"));
  const handleCheckLanguage = (e) => {
    setCheckedLang(e);
    localStorage.setItem("language", e);
    if (e == true) {
      document.body.dir = i18n.dir("en");
      i18n.changeLanguage("en");
    } else {
      i18n.changeLanguage("ar");
      document.body.dir = i18n.dir("ar");
    }
  };
  // console.log("checkedlang",checkedlang,"languages",languages)

  useEffect(() => {
    if (languages == null) {
      localStorage.setItem("language", true);
      i18n.changeLanguage("en");
      document.body.dir = i18n.dir("en");
    } else {
      if (languages == true) {
        i18n.changeLanguage("en");
        document.body.dir = i18n.dir("en");
      } else {
        i18n.changeLanguage("ar");
        document.body.dir = i18n.dir("ar");
      }
    }
  }, []);
  useEffect(() => {
    // localStorage.setItem('language', true);
    onSnapshot(searches, (snapshot) => {
      dispatch(
        GetTopSeacrhes(
          snapshot.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
        )
      );
    });
  }, []);
  useEffect(() => {
    onSnapshot(flag, (snapshot) => {
      dispatch(
        SetFlags(
          snapshot.docs.map((doc) => ({
            ...doc.data(),
            id: doc.id,
          }))
        )
      );
    });
    if (currentUser) {
      var today = new Date();
      var priorDate = new Date(new Date().setDate(today?.getDate() - 8));
      var notificationRef = query(
        collection(db, "notifications"),
        where("date", ">=", priorDate),
        where("toUid", "==", currentUser.uid)
      );
      onSnapshot(notificationRef, (snapshot) => {
        setNotifications(
          snapshot.docs
            .filter((doc) => !doc.data().status)
            .map((doc) => ({
              ...doc.data(),
              id: doc.id,
            }))
        );
        dispatch(
          SetNotifications(
            snapshot.docs
              .filter((doc) => !doc.data().status)
              .map((doc) => ({
                ...doc.data(),
                id: doc.id,
              }))
          )
        );
      });

      if (currentUser) {
        getFirebaseToken(currentUser.token, currentUser.uid);
      }
      const followingQuery = query(
        collection(db, "following"),
        where("idFollowFrom", "==", currentUser.uid)
      );
      onSnapshot(followingQuery, (snapshot) => {
        dispatch(
          GetAllMyFollowers(
            snapshot.docs
              .filter((doc) => !doc.data().status)
              .map((doc) => ({
                ...doc.data(),
                id: doc.id,
              }))
          )
        );
      });
    }
  }, [currentUser, mybags, i18n]);
  useEffect(() => {
    var currenciesarr = currencies;
    console.log(showSearchh, "this is to check");
  }, []);
  useEffect(() => {
    Aos.init();
  });

  useEffect(
    () => {
      // Usage:
    },
    [mybags],
    currentUser
  );
  // function ShopAll() {
  //   dispatch(getAllProductOnline([]));
  //   dispatch(getLastDoc(null));
  //   dispatch(GetProductJustViewdd([]));
  //   dispatch(GetProductAlsoLike([]));
  //   dispatch(GetProductFromSeller([]));
  //   dispatch(GetProductNewDrops([]));
  //   dispatch(GetProductTopPicks([]));
  //   dispatch(GetAllProductViewd([]));
  //   dispatch(GetLibasProduct([]));
  //   dispatch(GetAllProductVintage([]));
  //   dispatch(GetAllChanel([]));
  //   dispatch(GetAllAmina([]));
  //   dispatch(GetAllPradaReEdition([]));
  //   dispatch(GetAllChanelBoy([]));
  //   dispatch(GetAllBottega([]));
  //   dispatch(GetAllHermes([]));
  //   dispatch(GetAllBirkin([]));
  //   dispatch(GetAllBurberry([]));
  //   dispatch(IsBurberry(false));

  //   dispatch(GetAllDG([]));
  //   dispatch(IsDG(false));

  //   dispatch(GetAllLV([]));
  //   dispatch(IsLV(false));

  //   dispatch(GetAllDisel([]));
  //   dispatch(IsDisel(false));

  //   dispatch(GetAllGucci([]));
  //   dispatch(IsGucci(false));

  //   dispatch(GetAllMM([]));
  //   dispatch(IsMM(false));

  //   dispatch(GetAllZadig([]));
  //   dispatch(IsZadug(false));

  //   dispatch(IsJustView(false));
  //   dispatch(IsDrops(false));
  //   dispatch(IsTopPicks(false));
  //   dispatch(IsProductFromSeller(false));
  //   dispatch(IsProductAlsoLike(false));
  //   dispatch(IsProductLibas(false));
  //   dispatch(IsVintage(false));
  //   dispatch(IsChanel(false));
  //   dispatch(IsAmina(false));
  //   dispatch(IsPradaReEdition(false));
  //   dispatch(IsChanelBoy(false));
  //   dispatch(IsBottega(false));
  //   dispatch(IsHermes(false));
  //   dispatch(IsBirkin(false));
  // }
  function OpenedNotification() {
    if (
      currentUser &&
      notifications.filter(
        (notf) =>
          notf.toUid == currentUser.uid &&
          notf.isOpened == false &&
          notf.type != NOTIFICATION_TYPE_PRODUCT_PRICE_DROP
      ).length != 0
    ) {
      {
        notifications
          .filter(
            (notf) =>
              notf.toUid == currentUser.uid &&
              notf.isOpened == false &&
              notf.type != NOTIFICATION_TYPE_PRODUCT_PRICE_DROP
          )
          .map((notf) =>
            updateDoc(
              doc(db, "notifications", notf.id),

              { isOpened: true }
            )
          );
      }
    }
  }
  if (i18n.language == "ar") {
    var arabStyle = {
      letterSpacing: "0em",
      textAlign: "right",
    };
  } else {
    var arabStyle = {};
  }
  useEffect(() => {
    if (currentUser != null) {
      const balancesref = doc(db, "balances", currentUser.uid);
      onSnapshot(balancesref, (doc) => {
        dispatch(GetBalances({ ...doc.data(), id: doc.id }));
      });

      if (constant != undefined || constant.isReferralAvailable != undefined) {
        if (constant.isReferralAvailable == true) {
          checkReferral();
        }
      }
    }
  }, [currentUser, constant]);

  function checkReferral() {
    if (currentUser !== null && balances) {
      // for non verified users dont show this refer modal
      if (!currentUser?.emailVerified) return;
      const referred =
        balances.referred == undefined ? 0 : balances.referred.map((e) => e);
      const userProv = currentUser;
      var dismissed =
        userProv.referralDismiss && userProv.referralDismiss.map((e) => e);
      if (currentUser.referralDismiss == undefined) {
        dismissed = [false, false, false, false];
      }
      if (dismissed != undefined) {
        if (dismissed.length === 0) {
          dismissed.push(false, false, false, false);
        }
        if (currentUser.username) {
          if (referred.length >= 10 && referred.length != undefined) {
            console.log(">= 10");

            if (!dismissed[3]) {
              dispatch(SetReferlength(referred.length));
              SetShowCongrats(true);
              dispatch(SetUpdateReferral(3));
            }
          } else {
            if (referred.length >= 5 && referred.length != undefined) {
              console.log(">= 5");

              if (!dismissed[2]) {
                dispatch(SetReferlength(referred.length));
                SetShowCongrats(true);
                dispatch(SetUpdateReferral(2));
              }
            } else {
              if (referred.length != 0 && referred.length != undefined) {
                console.log("!= 0");

                if (!dismissed[1]) {
                  dispatch(SetReferlength(referred.length));
                  SetShowCongrats(true);
                  dispatch(SetUpdateReferral(1));
                }
              } else {
                if (!dismissed[0]) {
                  console.log("==0");
                  dispatch(SetReferlength(referred.length));
                  SetShowReferral(true);
                  dispatch(SetUpdateReferral(0));
                }
              }
            }
          }
        }
      }
    }
  }

  return (
    // <div className={`theNav w-100 ${hovermenu?`bg-white`:`bg-transparent`} `} style={{zIndex:'1'}}>
    <div className={"theNav w-100 bg-white"} style={{ zIndex: "1" }}>
      {showSearchh && (
        <NavBarMdal
          show={showSearchh}
          currencydefault={currencydefault}
          currentUser={currentUser}
          currencies={currencies}
          selectedcurrency={selectedcurrency}
          setSignIn={setSignIn}
          setSignUp={setSignUp}
          logoProf={logoProf}
          handleChange={handleChange}
          handleCheck={signOutUser}
          signOutUser={signOutUser}
          setShow={setShowSearchh}
          ShoppingBag={ShoppingBag}
          users={users}
          setShowNotification={setShowNotification}
          notifications={notifications}
        />
      )}

      {showSearch && (
        <SearchMenuModal
          show={showSearch}
          setShow={setShowSeacrh}
          setSeacrhDrop={setSeacrhDrop}
        />
      )}
      {/* {showreferral && (
        <ReferalModal show={showreferral} setShow={SetShowReferral} />
      )} */}
      {showcongrats && (
        <ThankYouModal show={showcongrats} setShow={SetShowCongrats} />
      )}
      {/* {<OfferModal showOffer={showOffer} setShowOffer={SetShowOffer}/>} */}

      {showNotification && (
        <NotificationModal
          show={showNotification}
          setShow={setShowNotification}
          users={users}
          notifications={notifications}
          currentUser={currentUser}
        />
      )}

      {signUp && (
        <SignUp
          signUp={signUp}
          setSignUp={setSignUp}
          handleSignIn={setSignIn}
        />
      )}
      {forgetpassword && (
        <ForgetPassword
          forgetShow={forgetpassword}
          handleforgetShow={setForgetpassword}
          handleSignIn={setSignIn}
        />
      )}
      {/* sign up modal opening */}
      {signIn && (
        <SignIn
          signIn={signIn}
          handleSignIn={setSignIn}
          handleSignUp={setSignUp}
          handleForgetpassword={setForgetpassword}
        />
      )}

      <div className="row m-0 px-md-4 px-1 w-100 pt-md-2 pt-4 pb-md-0 pb-4 d-flex justify-content-between align-items-center">
        <div className=" col-4 p-0 d-flex align-items-center d-lg-flex d-none">
          <div className=" searchnavbarwidth border-0  bg-transparent dropdown-toggle shopping-bag-btn">
            <div
              className="input-group"
              style={{
                backgroundColor: "#F5F5F5",
                borderRadius: "3px",
                flexWrap: "nowrap",
                direction: i18n.language === "ar" ? "rtl" : "ltr",
              }}
            >
              <span
                className="input-group-text bg-transparent"
                style={{
                  border: "none",
                  padding: "0.5rem 0.75rem",
                }}
              >
                <img
                  src={Search}
                  alt="Search"
                  style={{ width: "16px", height: "16px" }}
                />
              </span>

              <input
                type="text"
                className={`form-control px-0 ${
                  i18n.language == "en" ? "search-nav-new" : "search-navAr-new"
                }`}
                style={{
                  padding: "0.5rem 0.75rem",
                  minWidth: 0,
                  flex: 1,
                  direction: i18n.language === "ar" ? "rtl" : "ltr",
                }}
                placeholder={t("placeholderSeacrh")}
                onClick={() => setSeacrhDrop(true)}
                onChange={(e) => {
                  setSearchQ(e.target.value);
                  dispatch(getLastDoc(null));
                }}
                onKeyDown={handleSearch}
                value={searchQ}
                aria-label="Search"
              />
            </div>

            <div
              className={`dropdown  d-lg-block d-none  ${
                i18n.language == "en" ? "ms-4" : "me-4"
              }`}
            >
              {seacrhDrop == true ? (
                <ul
                  className={`position-absolute px-2 mt-3 ${
                    i18n.language == "en"
                      ? `dropdown-navSearch `
                      : `dropdown-navSearchAr`
                  }`}
                  onMouseLeave={() => setSeacrhDrop(false)}
                >
                  <li className="pt-3 pb-3">
                    <div className="row mx-0">
                      <div className="col-6 ">
                        <SearchComponent setSeacrhDrop={setSeacrhDrop} />
                      </div>
                      <div
                        className={`col-6  ${
                          i18n.language == "en"
                            ? "border-search"
                            : "border-searchAr"
                        }`}
                      >
                        <TopPicksSeacrh />
                      </div>
                    </div>
                  </li>
                </ul>
              ) : null}
            </div>
          </div>
        </div>

        <div className="d-md-none col-4">
          <button
            className="navbar-toggler float-right border-0 "
            onClick={() => setShowSearchh(true)}
            aria-label="Open Menu"
          >
            <img src={burger} className="burger" alt="Menu and settings" />
          </button>
        </div>
        {/* logo */}
        <div className="col-lg-4 col-md-6 col-4 p-0 justify-content-center d-flex px-md-0">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault(); // Prevent default navigation
              window.scrollTo({ top: 0, left: 0, behavior: "instant" }); // Scroll to top
              window.location.href = "/"; // Hard refresh
            }}
            style={{ cursor: "pointer" }}
          >
            <img src={logo} alt="libas-logo" className="img-fluid libas-logo" />
          </a>
        </div>
        <div className="col-4 d-md-none mx-0 px-0">
          <div className="w-100 d-flex align-items-center justify-content-end">
            {/* <div className={`${i18n.language == "en" ? "" : " ps-2"}`}>
              <a
                className={`d-lg-none d-block   ${
                  i18n.language == "en" ? " ps-4" : " ps-2"
                }`}
                data-toggle="modalsearch"
                id="bars"
                href="#modalsearch"
                aria-label="Open Search Modal"
                onClick={() => setShowSeacrh(true)}
              >
                <img
                  src={Search}
                  className="fa-search-brand3"
                  alt="Search designer brand "
                />
              </a>
            </div> */}

            <div className="position-relative d-flex align-items-center mx-2 px-md-1">
              <div
                onClick={() =>
                  branch.track("ShowBag") &
                  navigate("/checkout") &
                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  })
                }
              >
                <button
                  className="shoppoing-bag pe-2 d-lg-none d-block"
                  aria-label="View My Shopping Bag"
                >
                  <img
                    src={ShoppingBag}
                    alt="Shopping Bag Icon"
                    className="shopping-bag"
                  />
                  {currentUser != null ? (
                    mybags.length == 0 ? null : (
                      <div className="position-absolute card-number">
                        {mybags.length}
                      </div>
                    )
                  ) : null}
                </button>
              </div>
            </div>
          </div>
        </div>
        <span className="d-md-flex d-none col-6 p-0 d-flex search-toogle d-lg-none  ">
          <div className="w-100 d-flex align-items-center justify-content-end">
            <div className={`${i18n.language == "en" ? "" : " ps-2"}`}>
              <a
                className={`d-lg-none d-block   ${
                  i18n.language == "en" ? " ps-4" : " ps-2"
                }`}
                data-toggle="modalsearch"
                id="bars"
                href="#modalsearch"
                aria-label="Open Search Modal"
                onClick={() => setShowSeacrh(true)}
              >
                <img
                  src={Search}
                  className="fa-search-brand3"
                  alt="Search designer brand "
                />
              </a>
            </div>

            <div className="position-relative d-flex align-items-center mx-2 px-md-1">
              <div
                onClick={() =>
                  branch.track("ShowBag") &
                  navigate("/checkout") &
                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  })
                }
              >
                <button
                  className="shoppoing-bag pe-2 d-lg-none d-block"
                  aria-label="View My Shopping Bag"
                >
                  <img
                    src={ShoppingBag}
                    alt="Shopping Bag Icon"
                    className="shopping-bag"
                  />
                  {currentUser != null ? (
                    mybags.length == 0 ? null : (
                      <div className="position-absolute card-number">
                        {mybags.length}
                      </div>
                    )
                  ) : null}
                </button>
              </div>
            </div>
          </div>
        </span>
        <div
          className="col-4 p-0 justify-content-end justify-content-end  d-xl-flex d-none"
          id="navbarResponsive"
        >
          <ul className="navbar-nav me-auto mb-2 mb-lg-0 "></ul>
          <span className="navbar-text align-items-center d-flex">
            {/* <div className="dropdown  ">
                    <div
                      className=" border-0  bg-transparent dropdown-toggle shopping-bag-btn"

                    >
                      <div className="input-group " >
                        <span
                          className={`input-group-text  ${i18n.language == 'en' ? "fa-searchicon" : "fa-searchiconAr"}`}

                          id="basic-addon1"
                        >
                          <img src={Search} className="fa-search-brand2" />
                        </span>
                        <input
                          type="text"
                          className={`form-control px-0 ${i18n.language == 'en' ? "search-brand2" : "search-brand2Ar"}`}
                          onClick={() => setSeacrhDrop(true)}
                          // onFocus={()=>setSeacrhDrop(true)}
                          placeholder={t('placeholderSeacrh')}
                          aria-label="Username"
                          aria-describedby="basic-addon1"
                          onChange={e => setSearchQ(e.target.value)}
                          onKeyDown={handleSearch}
                          value={searchQ}
                        />
                      </div>

                    </div>

                    {seacrhDrop == true ?


                      <ul
                        className="position-absolute dropdown-navSearch px-2 mt-3"
                        onMouseLeave={() => setSeacrhDrop(false)}
                      >
                        <li className="pt-3 pb-3">
                          <div className="row mx-0">
                            <div className="col-6 ">
                              <SearchComponent setSeacrhDrop={setSeacrhDrop} />
                            </div>
                            <div
                              className={`col-6  ${i18n.language == 'en' ? "border-search" : "border-searchAr"}`}>
                              <TopPicksSeacrh />
                            </div>
                          </div>
                        </li>
                      </ul>
                      : null
                    }
                  </div> */}

            <div
              onClick={() =>
                navigate("/how-to-sell") &
                window.scrollTo({ top: 0, left: 0, behavior: "instant" })
              }
              className="navbar-linksSell  "
              style={arabStyle}
            >
              Sell an item
            </div>
            {!currentUser ? (
              <>
                <div
                  style={arabStyle}
                  onClick={() =>
                    setSignIn(true) &
                    dispatch(SetSignIn(true)) &
                    dispatch(SetSignUpp(false))
                  }
                  className={`navbar-links  ${
                    i18n.language == "en" ? "px-lg-3 px-3" : "px-lg-3 px-3"
                  }`}
                >
                  {t("Sign in")}
                </div>
                <div
                  style={arabStyle}
                  onClick={() =>
                    setSignIn(true) &
                    dispatch(SetSignUpp(true)) &
                    dispatch(SetSignIn(false))
                  }
                  className={`navbar-links  ${
                    i18n.language == "en" ? "px-lg-3 px-3" : "px-lg-3 px-3"
                  }`}
                >
                  {t("Sign up")}
                </div>
              </>
            ) : (
              <></>
            )}

            {/* <div
                    style={arabStyle}
                    onClick={() =>
                      navigate("/") &
                      window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "instant",
                      })
                    }
                    className={`navbar-links  ${
                      i18n.language == "en" ? "px-lg-3 px-3" : "px-lg-3 px-3"
                    }`}
                  >
                    {t("Home")}
                  </div> */}
            {/* <div
                    onClick={() =>
                      ShopAll() &
                      navigate("/products") &
                      window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "instant",
                      }) &
                      dispatch(SetSearch("")) &
                      dispatch(SetSelectdPage(0)) &
                      dispatch(SetSizeFilter([])) &
                      dispatch(SetBottomSizeFilter([]))&
                      dispatch(SetTopSizeFilter([])) &
                      dispatch(resetLoadingNumber(30))
                    }
                    className={`navbar-links  ${
                      i18n.language == "en" ? "pe-lg-3 pe-3" : "ps-lg-4 ps-3"
                    }`}
                    style={arabStyle}
                  >
                    {t("SHOP ALL")}
                  </div> */}

            {/* <div
                  
                  className={`navbar-links  ${i18n.language=="en"?'pe-lg-3 pe-3':'ps-lg-4 ps-3'}`}
                  style={{
                    display: currentUser === null ? "block" : "none", arabStyle
                  }}
                >
 <button
                          className="navbar-links btn-en px-0 "
                          data-toggle="modal"
                          data-target="#SignIn"
                          onClick={() => setSignIn(true)}
                          style={{
                            display: currentUser === null ? "block" : "none", arabStyle
                          }}
                        >
                          <span style={arabStyle}>

                            {t("Sign in")}
                          </span>
                        </button>
                </div>
                <div
                  
                  className={`navbar-links  ${i18n.language=="en"?'pe-lg-3 pe-3':'ps-lg-4 ps-3'}`}
                  style={{
                    display: currentUser === null ? "block" : "none", arabStyle
                  }}
                >

<button
                        onClick={() => setSignUp(true)
                        }

                        className="navbar-links btn-en"
                        data-toggle="modal"
                        data-target="#SignUp"
                        style={{
                          display: currentUser === null ? "block" : "none", arabStyle
                        }}
                      >
                        <span style={arabStyle}>

                          {t("Sign up")}
                        </span>


                      </button>
                </div> */}
            {/* <div
                    onClick={() =>
                      navigate("/About-US") &
                      window.scrollTo({ top: 0, left: 0, behavior: "instant" })
                    }
                    className="navbar-links px-lg-4  px-3 "
                  >
                    ABOUT US
                  </div> */}

            <div
              className={`position-relative  ${
                i18n.language == "en" ? "ps-4" : "ps-0"
              }`}
            >
              <div
                onClick={() =>
                  branch.track("ShowBag") &
                  navigate("/checkout") &
                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: "instant",
                  })
                }
              >
                <button
                  className="shoppoing-bag pe-2 "
                  aria-label="View My Shopping Bag"
                  style={{ position: "relative", bottom: "1px" }}
                >
                  <img
                    src={ShoppingBag}
                    alt="Shopping Bag Icon"
                    className="shopping-bag"
                  />

                  {currentUser != null ? (
                    mybags.length == 0 ? null : (
                      <div className="position-absolute card-number">
                        {mybags.length}
                      </div>
                    )
                  ) : null}
                </button>
              </div>
            </div>
            {currentUser == null ? null : (
              <div
                className={`dropdown  ${
                  i18n.language == "en" ? "ps-0" : "ps-0"
                }`}
              >
                <button
                  className=" border-0  bg-transparent dropdown-toggle shopping-bag-btn"
                  type="button"
                  id="dropdownMenu2"
                  data-bs-toggle="dropdown"
                  onClick={() => setTimeout(OpenedNotification, 2000)}
                  aria-expanded="false"
                >
                  <img
                    src={Notification}
                    alt="Notification"
                    className="notifaction mx-2"
                  />
                  {currentUser != null ? (
                    notifications.filter((notf) => notf.isOpened == false)
                      .length == 0 ? null : (
                      <div className="position-absolute card-number">
                        {
                          notifications.filter(
                            (notf) =>
                              notf.isOpened == false &&
                              notf.type != NOTIFICATION_TYPE_PRODUCT_PRICE_DROP
                          ).length
                        }
                      </div>
                    )
                  ) : null}
                </button>
                <ul
                  className={`dropdown-menu  px-4 ${
                    i18n.language == "en" ? "dropdown-nav2" : "dropdown-nav2Ar"
                  }`}
                  aria-labelledby="dropdownMenu2"
                  style={{
                    height: "600px",
                  }}
                >
                  <NotificationMap
                    users={users}
                    setShow={setShowNotification}
                    notifications={notifications}
                    currentUser={currentUser}
                  />
                </ul>
              </div>
            )}

            <div className="btn-group btn-profile ">
              <button
                type="button"
                className=" border-0  bg-transparent dropdown-toggle shopping-bag-btn"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                aria-label="Open Menu"
              >
                {currentUser != null ? (
                  <>
                    {
                      //users
                      //.filter((user) => user.id === currentUser.uid)
                      //.map((user) => (
                      <>
                        {currentUser.photoURL ? (
                          <img
                            src={currentUser.photoURL}
                            className="shopping-prof border-prof "
                            id={currentUser.uid}
                            alt="User profile"
                          />
                        ) : (
                          <img
                            src={avatar}
                            className="shopping-prof border-prof"
                            id={currentUser.uid}
                            alt="User profile"
                          />
                        )}
                      </>
                      //))
                    }
                  </>
                ) : (
                  <>
                    <img
                      src={logoProf}
                      className="shopping-prof"
                      alt="User profile"
                    />
                  </>
                )}
              </button>

              <ul
                className={`dropdown-menu position-absolute px-4 ${
                  i18n.language == "en" ? "dropdown-navEn" : "dropdown-navAr"
                }`}
                // className="dropdown-menu dropdown-nav position-absolute px-4"
                aria-labelledby="dropdownMenuButton2"
              >
                <li
                  className="welcome-nav  pt-3 pb-3 "
                  key="Welcome"
                  style={arabStyle}
                >
                  {t("welcome")}
                </li>
                <li key="SignIn">
                  <button
                    className="sign-in btn-en  pt-3"
                    data-toggle="modal"
                    data-target="#SignIn"
                    onClick={() =>
                      setSignIn(true) &
                      dispatch(SetSignIn(true)) &
                      dispatch(SetSignUpp(false))
                    }
                    style={{
                      display: currentUser === null ? "block" : "none",
                      arabStyle,
                    }}
                    aria-label="Open Sign In / Sign Up Modal"
                  >
                    <span style={arabStyle}>{t("Sign in")}</span>
                  </button>
                </li>

                <hr
                  className="dropdown-divider "
                  style={{
                    display: currentUser === null ? "block" : "none",
                  }}
                />
                <li key="SingUp">
                  <button
                    onClick={() =>
                      setSignIn(true) &
                      dispatch(SetSignUpp(true)) &
                      dispatch(SetSignIn(false))
                    }
                    className="sign-in btn-en"
                    data-toggle="modal"
                    data-target="#SignUp"
                    style={{
                      display: currentUser === null ? "block" : "none",
                      arabStyle,
                    }}
                    aria-label="Open Sign In / Sign Up Modal"
                  >
                    <span style={arabStyle}>{t("Sign up")}</span>
                  </button>

                  <hr
                    className="dropdown-divider "
                    style={{
                      display: currentUser === null ? "block" : "none",
                    }}
                  />
                </li>
                {currentUser != null ? (
                  <li
                    className="sign-in btn-en"
                    key="username"
                    style={arabStyle}
                  >
                    {currentUser != null ? (
                      <div
                        className="pt-3"
                        style={{
                          display: currentUser !== null ? "block" : "none",
                        }}
                      >
                        {currentUser == null ? null : (
                          <>
                            {i18n.language === "ar"
                              ? `${currentUser.username}@`
                              : `@${currentUser.username}`}
                          </>
                        )}
                      </div>
                    ) : null}
                  </li>
                ) : null}
                <hr
                  className="dropdown-divider "
                  style={{
                    display: currentUser !== null ? "block" : "none",
                  }}
                />

                {currentUser != null ? (
                  <>
                    <li className="sign-in btn-en text-start" key="myOrder">
                      <div
                        onClick={() =>
                          navigate(`/profile/${currentUser.uid}`) &
                          window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "instant",
                          })
                        }
                        className="link"
                        style={arabStyle}
                      >
                        {t("MyProfile")}
                      </div>
                    </li>
                    <hr
                      className="dropdown-divider "
                      style={{
                        display: currentUser !== null ? "block" : "none",
                      }}
                    />
                    <li className="sign-in btn-en text-start" key="myOrder1">
                      <div
                        onClick={() =>
                          navigate("/my-orders") &
                          window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "instant",
                          })
                        }
                        className="link"
                        style={arabStyle}
                      >
                        {t("myOrders")}
                      </div>
                    </li>
                    <hr
                      className="dropdown-divider "
                      style={{
                        display: currentUser !== null ? "block" : "none",
                      }}
                    />
                    <li className="sign-in btn-en text-start" key="myLikes">
                      <div
                        onClick={() =>
                          navigate("/wishlist") &
                          window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: "instant",
                          })
                        }
                        className="link"
                        style={arabStyle}
                      >
                        {t("myLikes")}
                      </div>
                    </li>
                    <hr
                      className="dropdown-divider "
                      style={{
                        display: currentUser !== null ? "block" : "none",
                      }}
                    />
                    {currentUser != null
                      ? constant == undefined ||
                        constant.isReferralAvailable == undefined
                        ? null
                        : constant.isReferralAvailable == true && (
                            <li
                              className="sign-in btn-en "
                              key="username"
                              style={arabStyle}
                              onClick={() =>
                                navigate("/referral-program-Libas") &
                                window.scrollTo({
                                  top: 0,
                                  left: 0,
                                  behavior: "instant",
                                })
                              }
                            >
                              {currentUser ? (
                                <span style={{ cursor: "pointer" }}>
                                  {t("Refer your friends")}
                                </span>
                              ) : null}
                            </li>
                          )
                      : null}
                    {constant != undefined &&
                    constant.isReferralAvailable == true ? (
                      <hr
                        className="dropdown-divider "
                        style={{
                          display: currentUser !== null ? "block" : "none",
                        }}
                      />
                    ) : null}
                  </>
                ) : null}

                <li
                  className="sign-in btn-en text-start align-items-center d-flex"
                  style={arabStyle}
                >
                  <span style={arabStyle}>{t("Language")}</span>
                  {i18n.language == "en" ? (
                    <span className="ps-2">Ar</span>
                  ) : (
                    <span className="pe-2 ">Eng</span>
                  )}

                  <Switch
                    checked={languages == null ? languages == true : languages}
                    onChange={handleCheckLanguage}
                    onColor="#C6AC96"
                    onHandleColor="#FFFFFF"
                    handleDiameter={30}
                    uncheckedIcon={false}
                    checkedIcon={false}
                    boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                    activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                    height={9}
                    width={35}
                    className="react-switch"
                    id="material-switch"
                  />
                  {i18n.language == "en" ? (
                    <span className="ps-2">Eng</span>
                  ) : (
                    <span className="ps-2">Ar</span>
                  )}
                </li>

                <hr className="dropdown-divider " />
                <li
                  className="sign-in btn-en text-start align-items-center d-flex justify-content-between currencyWidth"
                  key="currency2"
                  style={arabStyle}
                >
                  <span style={arabStyle}>{t("Currency")}</span>

                  <select
                    className="border-0 sign-in"
                    value={
                      !selectedcurrency ? currencydefault : selectedcurrency
                    }
                    onChange={handleChange}
                  >
                    {currencies?.map((currency) => (
                      <option
                        value={currency?.id}
                        className="selectedcurrency px-0 mx-0"
                        key={currency?.id}
                      >
                        {currency?.name}
                      </option>
                    ))}
                  </select>
                </li>
                <hr className="dropdown-divider " />

                {currentUser !== null ? null : <div className="pb-3"></div>}

                <button
                  className="sign-in btn-en px-0  pb-3"
                  data-toggle="modal"
                  data-target="#SignIn"
                  onClick={() => {
                    signOutUser();
                    dispatch(SetAddresses(null));
                    setSignIn(false);
                    dispatch(FillMybags([]));
                    dispatch(GetBalances([]));
                  }}
                  style={{
                    display: currentUser !== null ? "block" : "none",
                    arabStyle,
                  }}
                  aria-label="Sign Out"
                >
                  <span style={arabStyle}>{t("sign out")}</span>
                </button>
              </ul>
            </div>
          </span>
        </div>
      </div>
      <Menu setHoverMenu={setHoverMenu} hovermenu={hovermenu} />
    </div>
  );
}

export default NavBar;
